import React from 'react';

import { ThemeProvider } from '@app/contexts/ThemeContext';
import ErrorBoundary from '@shared/components/feedback/ErrorBoundary';

interface AppProvidersProps {
  children: React.ReactNode;
}

/**
 * Central location for all top-level React context providers used by the app.
 *
 * This keeps the root <App /> component lean (<100 LOC) and allows us to add
 * further providers (e.g. QueryClientProvider, I18nProvider) without bloating
 * the entry component.
 */
const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>{children}</ThemeProvider>
    </ErrorBoundary>
  );
};

export default AppProviders;
